module.exports = __webpack_public_path__ + "static/media/logoInterviewx.5233beec.svg";